module.exports = __webpack_public_path__ + "static/media/rectangle.6d6d6597.png";